import { render } from "./DashboardRankModal.vue?vue&type=template&id=9c37e3f4"
import script from "./DashboardRankModal.vue?vue&type=script&lang=js"
export * from "./DashboardRankModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__